import React, { useEffect, useRef, useState } from 'react';
import './OTPInputField.scss';

type OtpInputFieldProps = {
    length: number;
    onChangeOtp: (otp: string) => void;
    className?: string;
};

const OtpInputField: React.FC<OtpInputFieldProps> = ({ length, onChangeOtp, className }) => {
    const [otp, setOtp] = useState<string[]>(new Array(length).fill(''));
    const firstInputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        // Auto-focus the first input on component mount
        firstInputRef.current?.focus();
    }, []);


    const handleChange = (element: any, index: number) => {
        const value = element.value;
        const numericRegex = /^[0-9]$/;
    
        if (!value || !numericRegex.test(value)) return; // Ignore non-numeric

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        if (index < length - 1 && value) {
            element.nextSibling?.focus();
        }

        onChangeOtp(newOtp.join(''));
    };

    const handleBackspace = (element: any, index: number) => {
        // Once backspace is tapped we try to remove the data based on the following conditions
        // Case 1: First block - remove data of the block and stay there
        // Case 2 : last block - remove data of the block and stay there
        // case 3 : Any mid block - remove the data of the prev block and move there
        
        const newOtp = [...otp];

        if (index === 0) {
            newOtp[index] = '';
            setOtp(newOtp);
        } else if (index === length - 1 && otp[index] !== '') {
            newOtp[index] = '';
            setOtp(newOtp);
        }else {
            let prevIndex = index - 1;
            if (prevIndex >= 0) {
                newOtp[prevIndex] = '';
                setOtp(newOtp);
            }

            if (index > 0) {
                element.previousSibling?.focus();
            }
        }
       
        onChangeOtp(newOtp.join(''));
    };

    const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>, index: number) => {
        e.preventDefault();
        const pasteData = e.clipboardData.getData('Text').trim();
    
        // Reject if pasteData is empty or contains non-numeric characters
        if (!/^\d+$/.test(pasteData)) return;
    
        const pasteArray = pasteData.split('').slice(0, length);
    
        const newOtp = [...otp];
        for (let i = 0; i < pasteArray.length; i++) {
            newOtp[i] = pasteArray[i];
        }
    
        setOtp(newOtp);
        onChangeOtp(newOtp.join(''));
    
        const lastFilledIndex = Math.min(index + pasteArray.length - 1, length - 1);
        const inputs = document.querySelectorAll<HTMLInputElement>('.otp-digit-block');
        inputs[lastFilledIndex]?.focus();
    };
     

    return (
        <div className={`otp-input-field${className ? ` ${className}` : ''}`}>
            {otp.map((data, index) => (
                <input
                    key={index}
                    type="text"
                    maxLength={1}
                    value={data}
                    ref={index === 0 ? firstInputRef : null}
                    className='otp-digit-block'
                    onChange={(e) => handleChange(e.target, index)}
                    onKeyDown={(e: any) => {
                        if (e.key === 'Backspace') {
                            handleBackspace(e.target, index);
                        }
                    }}
                    onPaste={(e) => handlePaste(e, index)}
                />
            ))}
        </div>
    );
};

export default OtpInputField;


